[
  {
    "name": "2026 여름/가을 대회",
    "href": "/competitions/2026"
  },
  {
    "name": "초등부 대회",
    "href": "/competitions/jr"
  },
  {
    "name": "중·고등부 대회",
    "href": "/competitions/sr"
  }
]
